module.exports = __webpack_public_path__ + "static/slide-1-cf1f9bfda8bcee2626448714882092d7.jpg";